import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../../../Contexts/AuthContext";
import { updateFerme } from "../../../api/fermeApi";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import './fermeEdit.css';

export default function FermeEdit() {
    const { user, setUser } = useContext(AuthContext);
    const navigate = useNavigate();
    
    const [nom, setNom] = useState('');
    const [adresse, setAdresse] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (user?.ferme) {
            setNom(user.ferme.nom || '');
            setAdresse(user.ferme.adresse || '');
        }
    }, [user]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!nom || nom.trim() === '') {
            swal('Erreur', 'Le nom de la ferme est requis', 'error');
            return;
        }

        setLoading(true);

        const fermeData = {
            nom: nom,
            adresse: adresse || null,
        };

        console.log('Updating ferme:', user.ferme_id, fermeData);

        try {
            const updatedFerme = await updateFerme(user.ferme_id, fermeData);
            console.log('Ferme updated successfully:', updatedFerme);
            
            setUser({
                ...user,
                ferme: updatedFerme
            });

            swal('Succès', 'Ferme mise à jour avec succès', 'success');
            navigate('/admin');
        } catch (error) {
            console.error('Update error:', error);
            const errorMsg = error.response?.data?.message || 'Erreur lors de la mise à jour';
            swal('Erreur', errorMsg, 'error');
        } finally {
            setLoading(false);
        }
    }

    if (!user?.ferme) {
        return <div>Chargement...</div>;
    }

    return (
        <div className="user-form-container">
            <div className="user-form-card">
                <h2>Modifier la Ferme</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-grid">
                        <div className="form-group1">
                            <label>Nom de la ferme :<span style={{color:'red'}}> *</span></label>
                            <input
                                type="text"
                                value={nom}
                                onChange={(e) => setNom(e.target.value)}
                                required
                                placeholder="Nom de la ferme"
                            />
                        </div>

                        <div className="form-group1">
                            <label>Adresse :</label>
                            <input
                                type="text"
                                value={adresse}
                                onChange={(e) => setAdresse(e.target.value)}
                                placeholder="Adresse de la ferme"
                            />
                        </div>
                    </div>

                    <button type="submit" className="submit-btn" disabled={loading}>
                        {loading ? 'Mise à jour...' : 'Mettre à jour'}
                    </button>
                </form>
            </div>
        </div>
    );
}